import { render, staticRenderFns } from "./UiApple.vue?vue&type=template&id=99795400"
import script from "./UiApple.vue?vue&type=script&lang=js"
export * from "./UiApple.vue?vue&type=script&lang=js"
import style0 from "./UiApple.vue?vue&type=style&index=0&id=99795400&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports